import z from 'zod';

export const domainVerificationStatusSchema = z.enum(['pending', 'verified']);

export const domainVerificationCreateDTOSchema = z.object({
  domain: z.string().regex(z.regexes.domain),
});

export const domainVerificationDTOSchema = z.object({
  id: z.string(),
  domain: z.string(),
  status: domainVerificationStatusSchema,
  verifiedVia: z.enum(['dns_txt', 'legacy']),
  verifiedAt: z.string().nullable(),
  createdAt: z.string(),
});

export const domainVerificationInitiatedDTOSchema = z.object({
  id: z.string(),
  domain: z.string(),
  status: domainVerificationStatusSchema,
  token: z.string(),
  txtRecord: z.string(),
  createdAt: z.string(),
});

export const domainVerificationArrayDTOSchema = z.object({
  domainVerifications: z.array(domainVerificationDTOSchema),
});

export const domainVerificationCheckDTOSchema = z.object({
  verified: z.boolean(),
  status: domainVerificationStatusSchema.optional(),
  verifiedAt: z.string().optional(),
  error: z.enum(['token_not_found', 'dns_lookup_failed']).optional(),
});

export const domainVerificationIdSchema = z.object({
  id: z.string().min(1),
});
